import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';

// 레이아웃
import MainLayout from './layouts/MainLayout';
import AuthLayout from './layouts/AuthLayout';

// 페이지
import HomePage from './pages/HomePage';
import DashboardPage from './pages/dashboard/DashboardPage';
import ActivityDataInputPage from './pages/data/ActivityDataInputPage';
import PredictionPage from './pages/predictions/PredictionPage';
import ReportPage from './pages/reports/ReportPage';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';

function App() {
  // 실제 앱에서는 인증 상태를 Redux나 Context API로 관리하는 것이 좋습니다
  const [isAuthenticated, setIsAuthenticated] = useState(true); // 개발 편의를 위해 기본값 true로 설정

  // 인증 관련 함수들
  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
  };

  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Routes>
        {/* 공개 라우트 */}
        <Route element={<AuthLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage onLogin={handleLogin} />} />
          <Route path="/register" element={<RegisterPage />} />
        </Route>

        {/* 인증 필요 라우트 - 탭 시스템 적용 */}
        <Route element={<MainLayout onLogout={handleLogout} />}>
          <Route path="/dashboard" element={
            isAuthenticated ? <DashboardPage /> : <Navigate to="/login" replace />
          } />
          <Route path="/data/input" element={
            isAuthenticated ? <ActivityDataInputPage /> : <Navigate to="/login" replace />
          } />
          <Route path="/predictions" element={
            isAuthenticated ? <PredictionPage /> : <Navigate to="/login" replace />
          } />
          <Route path="/reports" element={
            isAuthenticated ? <ReportPage /> : <Navigate to="/login" replace />
          } />
          {/* 추가 라우트는 여기에 */}
          <Route path="/settings" element={
            isAuthenticated ? <div>설정 페이지</div> : <Navigate to="/login" replace />
          } />
          <Route path="/help" element={
            isAuthenticated ? <div>도움말 페이지</div> : <Navigate to="/login" replace />
          } />
          <Route path="/data/history" element={
            isAuthenticated ? <div>데이터 조회 페이지</div> : <Navigate to="/login" replace />
          } />
        </Route>

        {/* 404 페이지 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Box>
  );
}

export default App;
